import { NEXTJS_RSC_LOGGED_IN_HOME_PAGE_240411 } from "@faire/web-api/indigofair/settings/NEXTJS_RSC_LOGGED_IN_HOME_PAGE_240411";

import { useSetting } from "./__internal__/useSetting";

export const useSettingHomepageNextJS = (): boolean =>
  useSetting(NEXTJS_RSC_LOGGED_IN_HOME_PAGE_240411, false);
